<div class="googleReview mt-4" *ngIf="storDetails && storDetails.reviews.length > 0">
    <div class="d-flex justify-content-between align-items-center">
      <div class="grHead">
        <h2 class="boldLIght towLineHead">
            <strong><span class="f-32">Google</span></strong> Business Reviews
        </h2>
      </div>
      <div class="d-none d-md-block">
        <span class="write-review p-2" (click)="openGmbReviewUrl(storDetails.gmbReviewUrl)">Write a review
          <img src="/assets/dds-images/write-review.svg" alt="" class="pl-2">
        </span>
      </div>
    </div>
    <div class="d-block d-md-none">
      <span class="write-review p-2 d-flex justify-content-end" (click)="openGmbReviewUrl(storDetails.gmbReviewUrl)">Write a review
       &nbsp; <img src="/assets/dds-images/write-review.svg" alt="" class="pl-2">
      </span>
    </div>

    <div class="googleReviewSlide">
        <div class="grList" *ngIf="storDetails && storDetails.reviews.length > 0">
            <div class="grItem" *ngFor="let review of storDetails.reviews">
                <div class="giHead">
                    <span class="giLeft">
                        <h3 style="margin-bottom: auto;">{{review.display_Name}}</h3>
                        <i>Posted on : {{review.crt_Dt | date: 'dd/MM/yyyy hh:mm a'}}</i>
                    </span>
                    <span class="starRating">{{review.star_Rating}}</span>
                </div>
                <div class="reviws">
                    <p>{{review.comment}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
